export const REQUEST_FACILITIES_META_DATA = 'REQUEST_FACILITIES_META_DATA';
export const RECEIVE_FACILITIES_META_DATA = 'RECEIVE_FACILITIES_META_DATA';

export const receiveFacilitiesMetaData = (payload) => ({
  type: RECEIVE_FACILITIES_META_DATA,
  payload: payload
});


// WEBPACK FOOTER //
// ./src/actions/facilitiesMetaActions.js